/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCategoryDto } from '../models/backend-category-dto';
import { handbookCategoriesList } from '../fn/handbook/handbook-categories-list';
import { HandbookCategoriesList$Params } from '../fn/handbook/handbook-categories-list';
import { handbookTopicsRetrieve } from '../fn/handbook/handbook-topics-retrieve';
import { HandbookTopicsRetrieve$Params } from '../fn/handbook/handbook-topics-retrieve';
import { BackendTopicDto } from '../models/backend-topic-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiHandbookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `handbookCategoriesList()` */
  static readonly HandbookCategoriesListPath = '/api/handbook/categories/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `handbookCategoriesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookCategoriesList$Response(
    params?: HandbookCategoriesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCategoryDto>>> {
    return handbookCategoriesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `handbookCategoriesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookCategoriesList(
    params?: HandbookCategoriesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCategoryDto>> {
    return this.handbookCategoriesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCategoryDto>>): Array<BackendCategoryDto> => r.body),
    );
  }

  /** Path part for operation `handbookTopicsRetrieve()` */
  static readonly HandbookTopicsRetrievePath = '/api/handbook/topics/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `handbookTopicsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookTopicsRetrieve$Response(
    params: HandbookTopicsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTopicDto>> {
    return handbookTopicsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `handbookTopicsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookTopicsRetrieve(params: HandbookTopicsRetrieve$Params, context?: HttpContext): Observable<BackendTopicDto> {
    return this.handbookTopicsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTopicDto>): BackendTopicDto => r.body),
    );
  }
}
